import React from "react";

import { formatAmount } from "../../accessories/accessoryMoney";
import { lineKey } from "../../cart/cartLines";

const MoneyRow = ({ label, money, negative }) => {
  if (!money) return null;

  return (
    <div className={`sy-flow-money${negative ? " is-credit" : ""}`}>
      <span>{label}</span>
      <b>
        {negative ? "-" : ""}
        {formatAmount(money.value, money.currency)}
      </b>
    </div>
  );
};

const Recap = ({ summary }) => (
  <div className="sy-checkout-recap">
    {summary.carts.map((cart) => (
      <div className="sy-checkout-recap-supplier" key={cart.cartId}>
        <p className="sy-checkout-recap-name">{cart.supplierName || "Supplier"}</p>

        {cart.lines.map((line) => (
          <div className="sy-checkout-recap-line" key={lineKey(line)}>
            <span>
              <i className="sy-checkout-recap-qty">{line.quantity}</i>
              {line.name}
            </span>

            {line.lineAmount && (
              <b>{formatAmount(line.lineAmount.value, line.lineAmount.currency)}</b>
            )}
          </div>
        ))}
      </div>
    ))}
  </div>
);

const SummarySkeleton = () => (
  <div className="sy-checkout-summary-skeleton" aria-hidden="true">
    <span className="sy-flow-shimmer" style={{ width: "100%" }} />
    <span className="sy-flow-shimmer" style={{ width: "82%" }} />
    <span className="sy-flow-shimmer" style={{ width: "64%" }} />
    <span className="sy-flow-shimmer" style={{ width: "100%", height: 20 }} />
  </div>
);

const CheckoutSummary = ({ summary, quote, isQuoting, children }) => (
  <aside className="sy-flow-card">
    <div className="sy-flow-card-head">
      <h2 className="sy-flow-card-title">Order summary</h2>
      <span className="sy-flow-card-note">
        {`${summary.itemCount} ${summary.itemCount === 1 ? "item" : "items"}`}
      </span>
    </div>

    <div className="sy-flow-card-body">
      <Recap summary={summary} />

      <div className="sy-checkout-breakdown">
        {isQuoting && !quote ? (
          <SummarySkeleton />
        ) : quote ? (
          <>
            <MoneyRow label="Sub total" money={quote.subTotal} />
            <MoneyRow label="Discount" money={quote.discount} negative />
            <MoneyRow label="Delivery fee" money={quote.deliveryFee} />
            <MoneyRow label="Platform fee" money={quote.platformFee} />
            <MoneyRow label="Tax / VAT" money={quote.totalVAT} />

            <div className="sy-flow-total">
              <span>Total</span>
              <b>
                {formatAmount(quote.payableAmount?.value, quote.payableAmount?.currency)}
              </b>
            </div>
          </>
        ) : (
          <>
            <div className="sy-flow-money">
              <span>Sub total</span>
              <b>{formatAmount(summary.total, summary.currency)}</b>
            </div>

            <div className="sy-flow-money">
              <span>Delivery &amp; fees</span>
              <b>Pending</b>
            </div>

            <p className="sy-flow-hint">
              Choose a delivery type and address to see your final total.
            </p>
          </>
        )}
      </div>

      {children}
    </div>
  </aside>
);

export default CheckoutSummary;
